export default __webpack_public_path__ + "static/media/au-nt.cbe61370.svg";